module.exports = __webpack_public_path__ + "img/CB1-Off-1.39fb0f3e.gif";